import React, { useEffect, useContext, useState } from "react";
import { AppContext } from "../../../Context/AppContext";
import { useHistory } from "react-router-dom";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import { AttributeContext } from "./AttributeContext";
import Utils from "../../../Common/Utils";
import SkeletonElement from "../Category/Shimmer/SkeletonElement";

let lastSelectedAttribute = 0;
function AttrList(props) {
  const history = useHistory();
  let AttributeContextData = useContext(AttributeContext);
  let appData = useContext(AppContext);
  let industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;

  let [loading, setLoading] = React.useState(false);
  let [attributeList, setAttributeList] = React.useState([]);
  let [errorMessage, setErrorMessage] = React.useState(null);
  let [filteredAttributeList, setFilteredAttributeList] =
    useState(attributeList);

  async function load_Attributes(newAttributeFound = false) {
    setLoading(true);
    lastSelectedAttribute = 0;
    AttributeContextData?.setUpdatedAttributeId('');
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let ret = await ServiceWrapper.doGet(
      `${api_base_url}industry/${industryId}/attribute/list`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!ret.errorfound) {
      const sortedData = ret.data.data.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      });
      AttributeContextData.setAttributeId(sortedData[0]?.id);
      let attributes = sortedData;
      if (attributes.length > 0) {
        attributes = attributes.map((attribute) => ({
          ...attribute,
          showCopyIcon: false,
        }));
        if (lastSelectedAttribute === -1) {
          const newIndex = attributes.findIndex((e) => e.id === AttributeContextData.newAttributeId);
          lastSelectedAttribute = newIndex ?? 0
          attributes[lastSelectedAttribute].showCopyIcon = true;
        } else {
          attributes[lastSelectedAttribute].showCopyIcon = true;
        }
      } else {
        setLoading(false);
      }

      if (
        props.props.props.match.params.uid === undefined &&
        AttributeContextData.editingItem === null
      ) {
        // if (AttributeContextData.editingItem === null) {
        setTimeout(() => {
          if (sortedData.length > 0) {
            AttributeContextData.setEditingItem({
              form: "view",
              id: sortedData[0].id,
            });
            setAttributeList(attributes);
            setFilteredAttributeList(attributes);
            setLoading(false);
          }
        }, 2000);
        // }
      } else {
        setAttributeList(attributes);
        setFilteredAttributeList(attributes);
        setLoading(false);
        if (newAttributeFound) {
          const index = attributes.findIndex(
            (obj) => obj.id === AttributeContextData.newAttributeId
          );

          const item = attributes[index];
          updateAttributeDetailPage(index, item, attributes, newAttributeFound);
        }

        if (AttributeContextData.updatedAttributeId !== "") {
          const index = attributes.findIndex(
            (obj) => obj.id === AttributeContextData.updatedAttributeId
          );
          const item = attributes[index];
          updateAttributeDetailPage(index, item, null, false);
        }
      }

      if (window.location.pathname === "/gms/taxonomy/attribute/0") {
        if (
          AttributeContextData?.editingItem?.id === undefined ||
          AttributeContextData?.editingItem?.id === "0"
        ) {
          if (AttributeContextData?.newAttributeId) {
            AttributeContextData.setEditingItem({
              form: "view",
              id: "AttributeContextData?.newAttributeId",
            });
          } else {
            if (AttributeContextData.attributeDeleted) {
              AttributeContextData.setEditingItem({
                form: "view",
                id: sortedData[0]?.id ?? "",
              });
              AttributeContextData.setAttributeDeleted(false);
            } else {
              AttributeContextData.setEditingItem(null);
              setTimeout(() => {
                AttributeContextData.setEditingItem({
                  form: "edit",
                  id: "0",
                });
              }, 1000);
            }
          }
        } else {
          AttributeContextData.setEditingItem({
            form: "view",
            id: sortedData[0]?.id ?? "",
          });
        }
      }
    } else {
      setLoading(false);
      setErrorMessage("Error While Loading Attributes");
    }
    if (!AttributeContextData.editingItem && props.props.props) {
      AttributeContextData.setEditingItem({
        form: "view",
        id: props.props.props.match.params.uid,
      });
    }
    AttributeContextData.setUpdatedAttributeId("");
  }

  function updateAttributeDetailPage(
    index,
    item,
    resAttributes,
    newAttributeFound
  ) {
    if (filteredAttributeList.length !== attributeList.length) {
      // update filter list
      const attributes = filteredAttributeList.map((attribute) =>
        attribute.id === item.id
          ? { ...attribute, showCopyIcon: !attribute.showCopyIcon }
          : { ...attribute, showCopyIcon: false }
      );
      AttributeContextData.setAttributeId(item?.id ?? "");
      AttributeContextData.setEditingItem({ form: "view", id: item?.id ?? "" });
      setFilteredAttributeList(attributes);

      // update attribute list
      const attrList = attributeList.map((attribute) =>
        attribute.id === item.id
          ? { ...attribute, showCopyIcon: !attribute.showCopyIcon }
          : { ...attribute, showCopyIcon: false }
      );
      const attrIndex = attrList.findIndex(
        (attribute) => attribute.id === item.id
      );
      setAttributeList(attrList);
      lastSelectedAttribute = attrIndex;
    } else {
      const attributes = newAttributeFound
        ? resAttributes
        : filteredAttributeList;
      if (index !== lastSelectedAttribute && item) {
        AttributeContextData.setAttributeId(item?.id ?? "");
        AttributeContextData.setEditingItem({
          form: "view",
          id: item?.id ?? "",
        });
        attributes[index].showCopyIcon = !item.showCopyIcon;
        attributes[lastSelectedAttribute].showCopyIcon = false;
        setFilteredAttributeList(attributes);
        lastSelectedAttribute = index;
      }
    }
  }

  useEffect(() => {
    if (appData.pm.checkPermission("gmsattributes_read")) {
      if (props.props.props && props.props.props.match.params.uid) {
        AttributeContextData.setEditingItem({
          form: "view",
          id: props.props.props.match.params.uid,
        });
      }
      if (industryId) {
        load_Attributes(false);
      }
    } else {
      history.push("/workspace/module/permission/denied");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industryId, AttributeContextData.listReloadCounter]);

  useEffect(() => {
    if (AttributeContextData.newAttributeId !== "") {
      load_Attributes(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AttributeContextData.newAttributeId]);

  useEffect(() => {
    if (AttributeContextData.updatedAttributeId !== "") {
      load_Attributes(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AttributeContextData.updatedAttributeId]);

  async function handleSearchAttribute(value) {
    if (!Utils.isEmpty(value)) {
      let searchval = value.toString().trim().toLowerCase();
      let filteredData = attributeList.filter((item) => {
        return (
          (item.name != null && item.name.toLowerCase().includes(searchval))
        );
      });
      setFilteredAttributeList(filteredData);
    } else {
      setFilteredAttributeList(attributeList);
    }
  }

  useEffect(() => {
    if (appData.editingItem) {
      AttributeContextData.setEditingItem({
        form: "edit",
        id: "0",
      });
      appData.setEditingItem(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appData.editingItem]);

  return (
    <React.Fragment>
      {loading && (
        <div className="pe-3 ps-0">
          <SkeletonElement type={"title"} />
          <br />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
          <SkeletonElement type={"text"} />
        </div>
      )}

      {false && (
        <div className="p-1 bg-white alert alert-primary small" role="alert">
          <span className="fas fa-circle-notch fa-spin" />
          &nbsp;
        </div>
      )}

      {false && (
        <div className="p-1 bg-white alert alert-danger small" role="alert">
          <span className="fa fa-exclamation-triangle" />
          &nbsp;&nbsp;
        </div>
      )}

      {false && (
        <div className="p-1 bg-white alert alert-primary small" role="alert">
          <span className="fa fa-check" />
          &nbsp;&nbsp;
        </div>
      )}
      {!loading && errorMessage && (
        <div className="mt-2 bg-white alert alert-danger alert-sm" role="alert">
          <span className="fa fa-exclamation-triangle" />
          &nbsp;&nbsp;
          <strong>{errorMessage}</strong>
        </div>
      )}
      {!loading && !errorMessage && (
        <>
          <div className="top-0 left-0 col h-100 md:overflow-y-auto w-100 pe-2 md:max-h-full scrollbar-none">
            <div className="flex-shrink-0">
              <div className="p-0 pb-0">
                {attributeList.length > 0 && (
                  <input
                    type="text"
                    onChange={(e) => handleSearchAttribute(e.target.value)}
                    className="my-0 shadow-none form-control form-control-sm border-1"
                    style={{
                      fontWeight: 500,
                      fontSize: "0.8rem",
                    }}
                    placeholder="Search ..."
                  />
                )}
                &nbsp;
              </div>
              <div
                className="mt-0 "
                style={{
                  //maxHeight: "80vh",
                  overflow: "scroll",
                  paddingRight: "5px",
                }}
              >
                {!loading && (
                  <ul className="list-unstyled">
                    {attributeList.length > 0 ? (
                      filteredAttributeList
                      .map((item, index) => {
                        return (
                          <li key={index}>
                            <div
                              className="p-0 m-0 btn-industry w-100 collapsed text-truncate"
                              data-bs-toggle="collapse"
                              data-bs-target={`#item-${index}`}
                              aria-expanded="false"
                            >
                              <div className="w-100">
                                <span
                                  onClick={() => {
                                    updateAttributeDetailPage(
                                      index,
                                      item,
                                      null,
                                      false
                                    );
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {" "}
                                  <label
                                    
                                    title={item.name}
                                    className="text-truncate"
                                    style={{
                                      fontSize: "0.8rem",
                                      width: "90%",
                                      color: `${
                                        item.showCopyIcon
                                          ? "#091caa"
                                          : "#8D8D8D"
                                      }`,
                                      fontFamily: "Noto Sans",
                                    }}
                                  >
                                    {item.name}
                                  </label>
                                </span>
                              </div>
                            </div>
                          </li>
                        );
                      })
                    ) : (
                      <div
                        className="p-1 bg-white alert alert-primary"
                        role="alert"
                      >
                        No Attributes found
                      </div>
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
}

export default AttrList;
